import { Modal } from "react-bootstrap"
import { showError } from "../../../redux/counter/counterSlice"
import { useAppDispatch } from "../../../redux/store"
import { propertyLinkedServiceForms } from "./EditPropertyLinkedServiceForms"
import { bookingLinkedServiceForms } from "./EditBookingLinkedServiceForms"
import { bookingLinkedServiceCategory, bookingLinkedServiceName } from "../../Forms/BookingForm/BookingLinkedServiceHelpers"

export function EditLinkedServiceModal(props: {
    active: boolean,
    onClose: () => void,
    onSave: (linkedServiceData: any) => void,
    message?: string
    title?: string
    linkedServiceData?: any
    linkedServiceType?: string
}) {

    const {
        active,
        onClose,
        onSave,
        message = "",
        title = "Edit Linked Service",
        linkedServiceData = {},
        linkedServiceType = "" 
    } = props

    const dispatch = useAppDispatch()

    console.log('linkedServiceData', linkedServiceData)

    let EditLinkedServiceForm: any = null

    if (linkedServiceType === "property") {
        EditLinkedServiceForm = propertyLinkedServiceForms[linkedServiceData?.linkedService] ?? null
    }

    if (linkedServiceType === "booking") {
        const category = bookingLinkedServiceCategory(linkedServiceData?.linkedService)
        if (category) {
            EditLinkedServiceForm = bookingLinkedServiceForms[category]
        }
    }


    return (
        <Modal
            show={active}
            onHide={() => {
                onClose()
            }}
            size={'lg'}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message && (
                    <p className="text-lg font-semibold mb-4">{message}</p>
                )}



                {EditLinkedServiceForm ? (
                    <EditLinkedServiceForm
                        initialData={linkedServiceData}
                        onSubmit={(data: any) => {
                            console.log('data', data)
                            try {
                                const stringifiedOptions = JSON.stringify(data || {})
                                const updatedLinkedServicePayload = {
                                    ...linkedServiceData,
                                    linkedService: linkedServiceType === 'booking'
                                        ? bookingLinkedServiceName(linkedServiceData.linkedService, data)
                                        : linkedServiceData.linkedService,
                                    linkedServiceId: stringifiedOptions,
                                }
                                console.log('updatedLinkedServicePayload', updatedLinkedServicePayload)
                                onSave(updatedLinkedServicePayload)
                            } catch (e) {
                                console.log('error stringifying linked service data', e);
                                dispatch(showError('Error saving linked service data'))
                            }
                        }}
                        onCancel={onClose}
                    />
                ) : (
                    <>
                        Unsupported linked service type: {linkedServiceData?.linkedService}
                        <pre>
                            {JSON.stringify(linkedServiceData, null, 2)}
                        </pre>
                    </>
                )}

            </Modal.Body>
        </Modal >
    )
}

